(ns common.schema.entities.workspace.kyc.templates.demo.tenant
  (:require
   [common.schema.entities.workspace.kyc.templates.capman.tenant-config :as tenant-kyc-config]
   [common.schema.entities.workspace.kyc.templates.capman.pep :as pep]
   [common.schema.entities.workspace.kyc.templates.demo.tenant-ubo :as tenant-ubo]
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]
   [common.schema.entities.workspace.kyc.templates.demo.company-config :as company-config]))

(def schema
  {:kyc-template/template-name
   "Demo Tenant"

   :kyc-template/kyc-form-preface
   tenant-kyc-config/form-preface-text

   :kyc-template/svg-logo
   company-config/svg-logo


   :kyc-template/png-logo
   company-config/png-logo

   :kyc-template/help-email-address
   nil

   :kyc-template/kyc-form-title
   {:translations {:en "Tenant KYC"
                   :fi "Vuokralaisen KYC"}}

   :kyc.tenant/basic-information
   {:ord          1.0
    :translations {:en "Tenant's Basic information"
                   :fi "Vuokralaisen perustiedot"}
    :pdf-columns  2
    :questions    (questions-registry/resolve-questions
                   [[:kyc-tenant/name]
                    [:kyc-tenant/business-id]
                    [:kyc-tenant/registered-address]
                    [:kyc-tenant/zip-code]
                    [:kyc-tenant/city]
                    [:kyc-tenant/domicile]
                    [:kyc-tenant/industry]])}

   :kyc.tenant/actual-beneficiaries
   {:ord
    2.0
    :translations
    {:en "Actual beneficiaries of the tenant"
     :fi "Vuokralaisen tosiasialliset edunsaajat"}
    :skip-info?   true

    :info
    {:en
     (str
      "<p>The Act on Money Laundering defines beneficial owner as a person who either
     owns a company or otherwise exercises control over the company.</p>")

     :fi
     (str
      "<p>Rahanpesun torjuntalaki määrittelee tosiasiallisen edunsaajan henkilöksi,
     joka joko omistaa yrityksen tai muuten käyttää määräysvaltaa yhtiön toimien hallitsemiseen.</p>")}
    :more-info
    {:link-text    {:en "More information"
                    :fi "Lisätietoa täällä"}
     :info-header  {:en "Actual Beneficiaries"
                    :fi "Tosiasialliset edunsaajat"}
     :info-content
     {:en
      (str
       "<p>Beneficial Owners</p>"

       "<p>The Act on Money Laundering defines beneficial owner as a
        person who either owns a company or otherwise exercises control over the company.</p>"

       "<p>Beneficial owner status based on ownership or control refers to a natural person who:</p>"

       "<ol>"

       "<li>Directly or indirectly owns more than 25% of the shares of a legal entity or
        otherwise owns a corresponding share of a legal entity;</li>"

       "<li>Directly or indirectly uses more than 25% of the voting rights of a legal entity, and
        this number of votes is based on ownership, membership, articles of association,
        partnership agreement or comparable rules, or;</li>"

       "<li>Otherwise exercises actual control over a legal entity (e.g., based on a shareholder agreement).</li>"

       "</ol>"

       "<p></p>"

       "<p><i>If the above conditions are not met, the members of the board, the CEO,
        the liable partner or another person in a similar position are considered to be the beneficial owners.</i> </p>"


       "<p>The law also directly stipulates who are the actual beneficial owners in
        certain types of associations. These include:</p>"


       "<ol start=\"4\">"

       "<li>An ideological association referred to in the Association Act -
        actual beneficiaries are the members of the board registered in the association register</li>"

       "<li>A religious community referred to in the Freedom of Religion Act -
        beneficial owners are the members of the board registered in the register of religious communities</li>"

       "<li>A foundation referred to in the Foundation Act -
        beneficial owners are the members of the board and administrative council registered in the foundation register</li>"

       "<li>Housing companies and mutual real estate companies referred to in the Housing Companies Act -
        beneficial owners are the members of the board registered in the trade register</li>"

       "</ol>")
      :fi
      (str
       "<p>Omistajuuteen tai määräysvaltaan perustuvilla tosiasiallisella edunsaajalla
         tarkoitetaan luonnollista henkilöä, joka:</p>"

       "<ol>"

       "<li>omistaa suoraan tai välillisesti suuremman kuin 25 % osuuden oikeushenkilön osakkeista tai
         muuten omistaa vastaavan osuuden oikeushenkilöstä; </li>"

       "<li>käyttää suoraan tai välillisesti suurempaa kuin 25 % osuutta oikeushenkilön äänioikeuksista, ja
         tämä äänimäärä perustuu omistukseen, jäsenyyteen, yhtiöjärjestykseen, yhtiösopimukseen tai
         niihin verrattaviin sääntöihin, tai; </li>"

       "<li>käyttää muulla tavoin tosiasiallisesti määräysvaltaa oikeushenkilössä (esim. osakassopimukseen perustuen)</li>"

       "</ol>"

       "<p></p>"

       "<p><i>Jos edellä mainitut edellytykset eivät täyty, katsotaan tosiasialliseksi edunsaajaksi hallituksen jäsenet,
         toimitusjohtaja, vastuunalainen yhtiömies tai muu vastaavassa asemassa oleva henkilö.</i> </p>"


       "<p>Laissa on lisäksi säädetty tiettyjen yhteisömuotojen osalta suoraan siitä,
         ketkä niissä ovat tosiasiallisia edunsaajia. Näitä ovat:</p>"


       "<ol start=\"4\">"

       "<li>yhdistyslaissa tarkoitettu aatteellinen yhdistys -
         tosiasiallisia edunsaajia ovat yhdistysrekisteriin merkityt hallituksen jäsenet</li>"

       "<li>uskonnonvapauslaissa tarkoitettu uskonnollinen yhdyskunta -
         tosiasiallisia edunsaajia ovat uskonnollisten yhdyskuntien rekisteriin merkityt hallituksen jäsenet</li>"

       "<li>säätiölaissa tarkoitettu säätiö - tosiasiallisia edunsaajia ovat säätiörekisteriin
         merkityt hallituksen ja hallintoneuvoston jäsenet</li>"

       "<li>asunto-osakeyhtiölaissa tarkoitetut asunto-osakeyhtiöt ja keskinäiset kiinteistöosakeyhtiöt -
         tosiasiallisia edunsaajia ovat kaupparekisteriin merkityt hallituksen jäsenet</li>"

       "</ol>")}}

    :questions
    (questions-registry/resolve-questions
     [[:kyc-tenant/listed-in-stock-exchange?]
      [:kyc-tenant/ubo-edn {:data/template tenant-ubo/schema}]])}

   :kyc-tenant/confirmation
   {:ord
    12.0
    :translations
    {:en "Confirm entered data is correct"
     :fi "Syötettyjen tietojen vahvistaminen"}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-tenant/confirmation-place]
      [:kyc-tenant/confirmation-date]
      [:kyc-tenant/confirmation-name]])}

   :kyc-tenant/identifications
   {:ord
    13.0

    :translations
    {:en "Signer identification"
     :fi "Allekirjoittajien tunnistetiedot"}

    :keep-together?
    true

    :questions
    (questions-registry/resolve-questions
     [[:kyc-tenant/number-of-signers]
      [:kyc-tenant/signer-name-1]
      [:kyc-tenant/signer-email-1]
      [:kyc-tenant/signer-name-2]
      [:kyc-tenant/signer-email-2]])}

   :kyc-tenant/signature-info
   {:ord
    14.0
    :translations
    {:en ""
     :fi ""}

    :end-of-pdf?
    true

    :page-break-before?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-tenant/signature-info-1
       {:translations
        {:en (str
              "On behalf of the Tenant, I hereby confirm that the information "
              "I have declared in this form and in its appendices are true and correct.")
         :fi (str
              "Vuokralaisen puolesta vakuutan täten, että tässä lomakkeessa ja "
              "sen liitteissä antamani tiedot ovat oikeat ja paikkansapitävät.")}}]
      [:kyc-tenant/signature-info-2
       {:translations
        {:en (str
              "By signing the Tenant Information Form I understand that the collected personal data "
              "may be shared and disclosed within the CapMan Group to customer service and "
              "other customer relationship management.")
         :fi (str
              "Allekirjoittamalla vuokralaisen tunnistamislomakkeen ymmärrän, että "
              "kerättyjä henkilötietoja voidaan jakaa ja luovuttaa CapMan-konsernin sisällä "
              "asiakaspalvelulle ja muuhun asiakassuhteen hallintaan.")}}]])}

   :kyc-tenant/signature
   {:ord
    15.0

    :translations
    {:en "Signature"
     :fi "Allekirjoitus"}

    :end-of-pdf?
    true

    :conditional-block
    (fn [answers kyc-process]
      (and (some #{(:kyc-process/status kyc-process)}
                 [:kyc-process.status/signatures
                  :kyc-process.status/waiting-for-e-sign])
           (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])))

    :section-not-read-only
    (fn [_answers kyc-process]
      (and (some #{(:kyc-process/status kyc-process)}
                 [:kyc-process.status/signatures
                  :kyc-process.status/waiting-for-e-sign])))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-tenant/signature-place]
      [:kyc-tenant/signature-date]
      [:kyc-tenant/signature-name]
      [:kyc-tenant/signature-signature]])}

   :kyc-tenant/signature-2
   {:ord
    16.0

    :translations
    {:en "Signature 2"
     :fi "Allekirjoitus 2"}

    :end-of-pdf?
    true

    :conditional-block
    (fn [answers kyc-process]
      (and (some #{(:kyc-process/status kyc-process)}
                 [:kyc-process.status/signatures
                  :kyc-process.status/waiting-for-e-sign])
           (some #{(:kyc-tenant/number-of-signers answers)} [:two])))

    :section-not-read-only
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-tenant/signature-place-2]
      [:kyc-tenant/signature-date-2]
      [:kyc-tenant/signature-name-2]
      [:kyc-tenant/signature-signature-2]])}})
